export default __webpack_public_path__ + "a7a897d97d00a9c048d98ecd886824cf.png";